export const API_TOKEN_KEY = "spax_master_key";
export const API_URL = "https://api.sixpetal.com/sixpetal/v1/";
export const APP_VERSION = "1.1.0";
export const SPAX_ADMIN = "Admin";
export const SPAX_USER = "User";
export const SPAX_INDERNAL = "Internal";
export const USER_ACTIVE = "Active";
export const USER_INACTIVE = "Inactive";
